module.exports = __webpack_public_path__ + "static/aleksandra_before-16590d5700c047a8cc251324b04dddc3.png";